import configuratorChoices from '~/data/configuratorChoices/bagConfiguratorChoices';
import { ProductViewConfigurator } from '~/types/configurator';

let label;
let description;

export default {
    controls: [
        {
            key: 'color',
            keyLabel: 'color',
            label: 'Color',
            displayAsImages: true,
            choices: [configuratorChoices.colors.brown],
            detailsModalLabel: 'Color options:',
            hideOnProductPage: true,
        },
        {
            key: 'type',
            keyLabel: 'type',
            label: 'Type',
            choices: [
                {
                    label: (label = 'Single'),
                    detailsModalLabel: label,
                    value: 'single',
                    description: (description =
                        'This sturdy shipping carton is built to perfectly house one 3.625” wide gusseted or one 3.875” wide flat bottom bag.'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = 'Multiple'),
                    detailsModalLabel: label,
                    value: 'multiple',
                    description: (description =
                        'This versatile shipping carton is built to best fit a combination of two or three of our 3.625” wide gusseted or 3.875” wide flat bottom bags. The included corrugated filler will keep 2 bags snug.'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Type options:',
        },
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                {
                    label: (label = '7”w × 4.5”h × 2.75”d'),
                    detailsModalLabel: label,
                    value: '7-x-4.5-x-2.75',
                    description: (description =
                        'Perfectly fits one filled Roastar 8–16 oz gusset bag'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = '11.25”w × 8”h × 3”d'),
                    detailsModalLabel: label,
                    value: '11.25-x-8-x-3',
                    description: (description =
                        'Perfectly fits 2 or 3 filled Roastar 8–16 oz gusset bags '),
                    detailsModalDescription: description,
                },
                {
                    label: (label = '6.5”w × 4.875”h × 2.875”d'),
                    detailsModalLabel: label,
                    value: '6.5-x-4.875-x-2.875',
                    description: (description =
                        'Perfectly fits one filled Roastar 8–12 oz flat bottom bag'),
                    detailsModalDescription: description,
                },
                {
                    label: (label = '14.375”w × 6.5”h × 2.875”d'),
                    detailsModalLabel: label,
                    value: '14.375-x-6.5-x-2.875',
                    description: (description =
                        'Perfectly fits 2 or 3 filled Roastar 8–12 oz flat bottom bags'),
                    detailsModalDescription: description,
                },
            ],
            detailsModalLabel: 'Size options:',
        },
    ],
} as ProductViewConfigurator;
